var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_16125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_16125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0V30H31V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_16125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H8.5C4.08172 0 0.5 3.58172 0.5 8V22C0.5 26.4183 4.08172 30 8.5 30H22.5C26.9183 30 30.5 26.4183 30.5 22V8C30.5 3.58172 26.9183 0 22.5 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5H8.5C4.35786 0.5 1 3.85786 1 8V22C1 26.1421 4.35786 29.5 8.5 29.5H22.5C26.6421 29.5 30 26.1421 30 22V8C30 3.85786 26.6421 0.5 22.5 0.5Z",
    stroke: "white",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3346 8.33398H16.6273L13.6643 21.6673H15.3716L18.3346 8.33398ZM7.49356 14.4114L12.0769 9.82806L13.2554 11.0066L9.26133 15.0007L13.2554 18.9948L12.0769 20.1733L7.49356 15.5899L6.9043 15.0007L7.49356 14.4114ZM24.5054 14.4114L19.9221 9.82806L18.7436 11.0066L22.7377 15.0007L18.7436 18.9948L19.9221 20.1733L24.5054 15.5899L25.0947 15.0007L24.5054 14.4114Z",
    fill: "white",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_16125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.48ed2d865d3a8a375245146f2d4a192c.svg";
export { ForwardRef as ReactComponent };